import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTitulareForm } from '../Validations/ValidationsTitulare'; // Asegúrate de crear esta validación

export default function EditTitulareForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        terceroId: '',
        fecha: '',
        observaciones: '',
        sepulturaId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTitulare = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/titulares/${id}`);
                setFormData({
                    id: response.data.id || '',
                    terceroId: response.data.terceroId || '',
                    fecha: response.data.fecha || '',
                    observaciones: response.data.observaciones || '',
                    sepulturaId: response.data.sepulturaId || ''
                });
            } catch (err) {
                setError('Error al cargar los datos del titular.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTitulare();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Formulario enviado con datos:', formData); // Log para depurar
        const validationErrors = await validateTitulareForm(formData);
        console.log('Errores de validación:', validationErrors); // Log de validación
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                console.log('Actualizando datos en el servidor...');
                await axios.put(`/titulares/${id}`, formData);
                console.log('Actualización exitosa.');
                navigate('/home/titulares'); // Redirigir al listado después de guardar
            } catch (err) {
                setError('Error al actualizar el titular. Por favor, intente de nuevo.');
                console.error('Error updating titular:', err);
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors); // Mostrar errores si la validación falla
        }
    };

    if (isLoading) return <div className="text-center mt-8 text-blue-600">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8 p-6 bg-white rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-blue-700">Editar Titular</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-blue-700 mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-blue-700 mb-1">Tercero ID</label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`w-full p-2 border ${errors.terceroId ? 'border-red-500' : 'border-blue-200'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        required
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic mt-1">{errors.terceroId}</p>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-blue-700 mb-1">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`w-full p-2 border ${errors.fecha ? 'border-red-500' : 'border-blue-200'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        required
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic mt-1">{errors.fecha}</p>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-blue-700 mb-1">Observaciones</label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-2 border ${errors.observaciones ? 'border-red-500' : 'border-blue-200'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic mt-1">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-blue-700 mb-1">Sepultura ID</label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`w-full p-2 border ${errors.sepulturaId ? 'border-red-500' : 'border-blue-200'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        required
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic mt-1">{errors.sepulturaId}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white p-2 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-300"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Titular'}
                </button>
            </form>
        </div>
    );
}


/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTitulareForm } from '../Validations/ValidationsTitulare'; // Asegúrate de crear esta validación

export default function EditTitulareForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        terceroId: '',
        fecha: '',
        observaciones: '',
        sepulturaId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTitulare = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/titulares/${id}`);
                setFormData({
                    id: response.data.id || '',
                    terceroId: response.data.terceroId || '',
                    fecha: response.data.fecha || '',
                    observaciones: response.data.observaciones || '',
                    sepulturaId: response.data.sepulturaId || ''
                });
            } catch (err) {
                setError('Error al cargar los datos del titular.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTitulare();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Formulario enviado con datos:', formData); // Log para depurar
        const validationErrors = await validateTitulareForm(formData);
        console.log('Errores de validación:', validationErrors); // Log de validación
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                console.log('Actualizando datos en el servidor...');
                await axios.put(`/titulares/${id}`, formData);
                console.log('Actualización exitosa.');
                navigate('/home/titulares'); // Redirigir al listado después de guardar
            } catch (err) {
                setError('Error al actualizar el titular. Por favor, intente de nuevo.');
                console.error('Error updating titular:', err);
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors); // Mostrar errores si la validación falla
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8">
            <h2 className="text-2xl font-bold mb-4">Editar Titular</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border rounded"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1">Tercero ID</label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.terceroId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                <div>
                    <label className="block mb-1">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.fecha ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                <div>
                    <label className="block mb-1">Observaciones</label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block mb-1">Sepultura ID</label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.sepulturaId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Titular'}
                </button>
            </form>
        </div>
    );
}
    */